import { useState } from 'react';
import { Menu, MenuItem, Collapse } from '@mui/material';
import { IconFilter, IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import PropTypes from 'prop-types';

import Button from '../buttons/Button';
import Checkbox from '../inputs/Checkbox';

const PAGE_TYPE_OPTIONS = [
  { value: 'standard', label: 'Donation Pages' },
  { value: 'campaign', label: 'Campaign Donation Pages' },
];

const getButtonClassName = (open, active) => {
  if (open) return 'text-primary-600';
  if (active) return 'text-primary-700 !bg-primary-50 border-primary-200';
  return '';
};

const Filters = ({ typeFilters, setTypeFilters }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [typeOpen, setTypeOpen] = useState(true);
  const [selectedTypes, setSelectedTypes] = useState(typeFilters);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectType = (type) => {
    if (selectedTypes.includes(type)) {
      setSelectedTypes((prev) => prev.filter((t) => t !== type));
      return;
    }
    setSelectedTypes((prev) => [...prev, type]);
  };

  const handleApplyFilters = () => {
    setTypeFilters(selectedTypes);
    handleClose();
  };

  return (
    <>
      <Button
        title="Filters"
        LeftIcon={IconFilter}
        onClick={handleClick}
        className={getButtonClassName(open, typeFilters.length > 0)}
      />

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        classes={{
          paper: 'w-[320px] max-h-[412px] !rounded-lg mt-0.5 !overflow-hidden',
          list: '!p-0',
        }}
      >
        <ul className="max-h-[340px] divide-y divide-gray-50 overflow-y-auto">
          <li className="flex items-center justify-between px-4 py-3">
            <p className="text-base font-semibold text-gray-950">Filters</p>
            <button className="text-sm text-gray-600" onClick={() => setSelectedTypes([])}>
              Reset all
            </button>
          </li>

          <MenuItem
            classes={{ root: '!justify-between !py-3 !border-solid' }}
            onClick={() => setTypeOpen((prev) => !prev)}
          >
            <p className="text-caption1 font-semibold uppercase text-gray-950">Type</p>
            {typeOpen ? (
              <IconChevronDown size={16} className="text-gray-600" />
            ) : (
              <IconChevronUp size={16} className="text-gray-600" />
            )}
          </MenuItem>

          <Collapse in={typeOpen}>
            <li className="space-y-3 px-4 py-3">
              {PAGE_TYPE_OPTIONS.map((option) => (
                <Checkbox
                  key={`checkbox-${option.value}`}
                  id={option.value}
                  label={option.label}
                  value={option.value}
                  checked={selectedTypes.includes(option.value)}
                  onChange={() => handleSelectType(option.value)}
                  labelClassName="grow"
                />
              ))}
            </li>
          </Collapse>
        </ul>

        <li className="border-t border-gray-50 p-4">
          <Button title="Apply" color="primary" className="w-full" onClick={handleApplyFilters} />
        </li>
      </Menu>
    </>
  );
};

Filters.propTypes = {
  typeFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  setTypeFilters: PropTypes.func.isRequired,
};

export default Filters;
